import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from "ng-nice-select";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FilePondModule } from 'ngx-filepond';

import { ImportProductModalComponent } from '@teem/product-module/modals/import-product-modal/import-product-modal.component';
import { ProductGridComponent } from '@teem/product-module/components/product-grid/product-grid.component';
import { ProductTableComponent } from '@teem/product-module/components/product-table/product-table.component';
import { AddProductsComponent } from '@teem/product-module/modals/add-products/add-products.component';
import { EditProductComponent } from '@teem/product-module/modals/edit-product/edit-product.component';
import { ProductsRoutingModule } from '@teem/product-module/products-routing.module';
import { ProductsComponent } from '@teem/product-module/products.component';
import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';
import { ModifierComponent } from '@teem/product-module/components/modifier/modifier.component';


@NgModule({
  declarations: [
  	ProductsComponent,
  	ProductGridComponent,
    ProductTableComponent,
  	AddProductsComponent,
  	EditProductComponent,
    ImportProductModalComponent,
    ModifierComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    SharedModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NiceSelectModule,
    NgbModule,
    FilePondModule,
    ProductsRoutingModule
  ]
})
export class ProductsModule { }
